<template>
  <b-card class="border rounded-xl border-gray-200 mb-3">
    <div class="mb-3 text-sm md:text-base font-semibold text-[#333333]">
      Pilih Ekspedisi<span class="text-danger">*</span>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5">
      <div
        v-for="(item, index) in shipment"
        :key="index"
        class="border border-gray-200 rounded-xl overflow-hidden bg-white flex flex-col"
      >
        <!-- Header: logo + toggle -->
        <div class="bg-[#F8FAFC] border-b border-gray-200 px-3.5 py-2.5 flex items-center justify-between">
          <b-img
            :src="item.image_path"
            :alt="item.shipping_name"
            class="h-6 max-w-[85px] object-contain"
          />
          <b-form-checkbox
            :id="`toggle-shipment-${index}`"
            :checked="item.enabled"
            switch
            class="custom-shipment-switch mb-0"
            @change="val => onToggleShipment(index, val)"
          />
        </div>

        <!-- Services -->
        <div class="p-3.5 bg-white space-y-2">
          <div
            v-for="(service, si) in item.services"
            :key="si"
            class="flex items-center justify-between"
          >
            <span class="text-sm text-[#333333]">{{ service.service_name }}</span>
            <b-form-checkbox
              :id="`checkbox-${index}-${si}`"
              :checked="service.is_selected"
              :disabled="!item.enabled"
              class="mb-0"
              @change="val => onServiceChange(index, si, val)"
            />
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import apiGetShipment from '../service/api.shipment.service'

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shipment: [],
      isInternalUpdate: false,
    }
  },
  watch: {
    'formData.shipments': {
      handler() {
        if (this.isInternalUpdate) return
        this.updateShipmentSelection()
        this.$emit('validate')
      },
      deep: true,
    },
  },
  mounted() {
    this.getShipmentData()
  },
  methods: {
    async getShipmentData() {
      try {
        const { data } = await apiGetShipment()
        this.shipment = (data.data || []).map(item => {
          const hasSelection = this.isShipmentSelected(item.id)
          return {
            shipping_name: item.shipping_name,
            image_path: item.image_path,
            id: item.id,
            enabled: hasSelection,
            services: [
              {
                service_name: 'Regular',
                is_selected: this.isServiceSelected(item.id, 'regular'),
                value: 'regular',
              },
              ...(item.is_cargo
                ? [{
                  service_name: 'Trucking / Cargo',
                  value: 'cargo',
                  is_selected: this.isServiceSelected(item.id, 'cargo'),
                }]
                : []
              ),
            ],
          }
        })
        this.$emit('validate')
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data Expedisi' })
        this.shipment = []
      }
    },
    isShipmentSelected(id) {
      return (this.formData.shipments || []).some(s => s.shipment_id === id)
    },
    isServiceSelected(id, type) {
      return (this.formData.shipments || []).some(s => s.shipment_id === id && s.shipment_type === type)
    },
    onToggleShipment(itemIndex, enabled) {
      const updatedShipment = this.shipment.map((s, i) => {
        if (i !== itemIndex) return s
        return {
          ...s,
          enabled,
          services: s.services.map(sv => ({ ...sv, is_selected: enabled })),
        }
      })
      this.$set(this, 'shipment', updatedShipment)
      this.selectShipment()
    },
    onServiceChange(itemIndex, serviceIndex, val) {
      const updatedShipment = this.shipment.map((s, i) => {
        if (i !== itemIndex) return s
        const updatedServices = s.services.map((sv, si) => {
          if (si !== serviceIndex) return sv
          return { ...sv, is_selected: val }
        })
        const hasAnySelected = updatedServices.some(sv => sv.is_selected)
        return {
          ...s,
          enabled: hasAnySelected,
          services: updatedServices,
        }
      })
      this.$set(this, 'shipment', updatedShipment)
      this.selectShipment()
    },
    selectShipment() {
      const selected = []
      this.shipment.forEach(item => {
        if (!item.enabled) return
        item.services.forEach(service => {
          if (service.is_selected) {
            selected.push({
              shipment_id: item.id,
              shipment_type: service.value,
            })
          }
        })
      })
      this.isInternalUpdate = true
      this.$set(this.formData, 'shipments', selected)
      this.$nextTick(() => { this.isInternalUpdate = false })
      this.$emit('validate')
    },
    updateShipmentSelection() {
      if (!this.shipment.length) return
      const shipments = this.formData.shipments || []
      const updated = this.shipment.map(shipmentItem => {
        const services = shipmentItem.services.map(s => ({
          ...s,
          is_selected: shipments.some(sel => sel.shipment_id === shipmentItem.id && sel.shipment_type === s.value),
        }))
        const hasSelection = services.some(s => s.is_selected)
        return { ...shipmentItem, services, enabled: hasSelection }
      })
      this.$set(this, 'shipment', updated)
    },
  },
}
</script>

<style lang="scss">
.custom-shipment-switch {
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #F97316 !important;
    background-color: #F97316 !important;
  }
}

</style>
